
import Swal from "sweetalert2";
import React, { Component } from "react";
import { Modal } from "react-bootstrap";
import Navbar from "../../../components/Navbar.js";
import Resizer from "react-image-file-resizer";
import Select from "react-select";
import Switch from "react-switch";
import LOGO from "../../../assets/images/logo.png";
import SignatureCanvas from 'react-signature-canvas';
import {
    locale,
    tokens,
    select_style,
    required,
    // alert
    success,
    success_url,
    alert,
    alert_url,
    // function
    logout,
    number_zero,
    format_date,
    toFixed,
    total,
    validate,
    random_charactor,
    float,
    // api
    GET,
    POST,
    PUT,
    DELETE,
    error_message,
    // storage
    removeStorage,
    getStorage,

    validate_email,
    validate_th,
    validate_en,
    validate_en_number,

    LinktoBase64,
    // component
    DatePicker,
} from "../../../components/CustomComponent.js";

import "../../../components/global.js";
import "../../../assets/css/bootstrap.css";
import "../../../assets/css/index.css";

export default class Dashboard extends Component {
    constructor(props) {
        super(props)
        this.state = {
            modal_add_supplier: false,

            loading: false,
            item_list: [],


            data_supplier: [],
            data_product: [],
            data_license_plate: [],

            pre_po_main_id: "",
            pre_po_main_number: "",
            date: "",
            remark: "",

            company_id: "",

            index: -1,
            product_index: -1,
            readOnly: false
        }
    }
    async componentDidMount() {
        this.setState({ loading: true });
        await this.GetSupplier();
        await this.getProductAll();
        await this.GetMember();
        if (this.props.location.query.id) {
            this.GetById(this.props.location.query.id)
        }
        if (this.props.location.query.type === "readonly") {
            this.setState({ readOnly: true });
        }
        this.setState({ loading: false });
    }
    GetMember = async () => {
        let body = {
            page: 0,
            data_search: "",
            member_id: ""
        }
        let result = await GET(tokens, "v1/TH/member-info/list/" + getStorage("branch").branch_id, body);
        if (result && result.status) {
            console.log("GetMember:", result)
            let data_license_plate = [];
            for (let member of result.data) {
                for (let car_list of member.car_list) {
                    data_license_plate.push({ label: car_list, value: car_list })
                }
            }
            this.setState({
                data_license_plate: data_license_plate
            });
        }
    }
    GetById = async (id) => {

        let body = {
            page: 0,
            data_search: "",
            pre_po_main_id: id
        }
        let result = await GET(tokens, "v1/TH/purchase-order/pre/list/" + getStorage("branch").branch_id, body);
        if (result && result.status) {
            console.log("GetById:", result);
            let data = result.data;
            this.setState({
                pre_po_main_id: id,
                date: data.date ? data.date : "",
                remark: data.remark ? { value: data.remark, label: data.remark } : "",
                pre_po_main_number: data.pre_po_main_number,
                item_list: data.pre_po_center.map(item => {
                    return {
                        pre_po_center_id: item.pre_po_center_id,
                        company_id: { value: item.relation_company_supplier.company_id, label: item.relation_company_supplier.company_name },
                        decision_status: item.decision_status === 1 ? true : false,
                        picture: "",
                        product_code: "",
                        quantity: "",
                        price_by_item: "",
                        pre_po_list: item.pre_po_list.map(product => {
                            return {
                                pre_po_list_id: product.pre_po_list_id,
                                picture: product.picture,
                                product_code: product.relation_product_main.product_code ? this.state.data_product.filter(e => e.value === product.relation_product_main.product_code)[0] : "",
                                quantity: product.quantity,
                                price_by_item: product.price_by_item,
                                total_price_by_item: product.total_price_by_item
                            }
                        })
                    }
                })
            });
            setTimeout(() => {
                console.log(this.state.item_list);
            }, 10);
        }
    }
    GetSupplier = async () => {
        let body = {
            page: 0,
            data_search: "",
            company_type: 2,
            company_id: ""
        }
        let result = await GET(tokens, "v1/TH/company-info/list/" + getStorage("branch").branch_id, body);
        if (result && result.status) {
            console.log(result);
            this.setState({ data_supplier: result.data.map(e => { return { value: e.company_id, label: e.company_name } }) });
        }
    }
    getProductAll = async () => {
        let body = {
            page: 0,
            data_search: "",
            product_code: ""
        }
        let result = await GET(tokens, "v1/TH/product-manage/product/list/" + getStorage("branch").branch_id, body);
        if (result && result.status) {
            console.log(result);
            this.setState({ data_product: result.data.map(e => { return { value: e.product_code, label: e.product_name, ...e } }) });
        }
    }
    Create = async () => {
        if (!this.state.date) {
            alert("warning", "แจ้งเตือน", "กรุณาเลือกวันที่เอกสาร");
            return;
        }
        this.setState({ loading: true });
        let data = {
            date: format_date(this.state.date, "dd/mm/yyyy", "en"),
            remark: this.state.remark ? this.state.remark.value : "",
            pre_po_center: this.state.item_list.map(item => {
                return {
                    pre_po_center_id: item.pre_po_center_id,
                    company_id: item.company_id.value,
                    decision_status: item.decision_status ? 1 : 0,
                    pre_po_list: item.pre_po_list.map(product => {
                        return {
                            pre_po_list_id: product.pre_po_list_id,
                            product_code: product.product_code ? product.product_code.value : "",
                            price_by_item: Number(product.price_by_item),
                            quantity: Number(product.quantity),
                            total_price_by_item: Number(product.total_price_by_item),
                            picture: product.picture
                        }
                    })
                }
            }),
        }
        let result = await POST(tokens, "v1/TH/purchase-order/pre/create/" + getStorage("branch").branch_id, data);
        if (result && result.status) {
            success_url("/order/list-approve-order");
        }
        this.setState({ loading: false });
    }
    Update = async () => {
        if (!this.state.date) {
            alert("warning", "แจ้งเตือน", "กรุณาเลือกวันที่เอกสาร");
            return;
        }
        this.setState({ loading: true });
        let data = {
            pre_po_main_id: this.state.pre_po_main_id,
            date: format_date(this.state.date, "dd/mm/yyyy", "en"),
            remark: this.state.remark ? this.state.remark.value : "",
            pre_po_center: this.state.item_list.map(item => {
                return {
                    pre_po_center_id: item.pre_po_center_id,
                    company_id: item.company_id.value,
                    decision_status: item.decision_status ? 1 : 0,
                    pre_po_list: item.pre_po_list.map(product => {
                        return {
                            pre_po_list_id: product.pre_po_list_id,
                            product_code: product.product_code ? product.product_code.value : "",
                            price_by_item: Number(product.price_by_item),
                            quantity: Number(product.quantity),
                            total_price_by_item: Number(product.total_price_by_item),
                            picture: product.picture
                        }
                    })
                }
            }),
        }
        let result = await PUT(tokens, "v1/TH/purchase-order/pre/update", data);
        if (result && result.status) {
            success_url("/order/list-approve-order");
        }
        this.setState({ loading: false });
    }
    import_file = (e) => {
        this.changePhoto(e.target.files[0])
        document.getElementById("file").value = "";
        document.getElementById("file").file = null;
    }
    changePhoto = async (file) => {
         
        if (!file.type.includes("image")) {
            alert("error", "แจ้งเตือน", "ไม่สามารถอัพโหลดไฟล์ได้เนื่องจากไม่รองรับรูปแบบไฟล์");
            return
        }
        let reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = (e) => { }
        new Promise((resolve) => {
            Resizer.imageFileResizer(
                file, 512, 512, "JPG", 100, 0,
                (uri) => {
                    let item_list = this.state.item_list;
                    item_list[this.state.index].picture = uri.split(",")[1];
                    this.setState({ item_list: item_list });
                },
                "base64"
            );
        });
    }
    import_file_sub = (e) => {
        this.changePhoto_sub(e.target.files[0])
        document.getElementById("file_sub").value = "";
        document.getElementById("file_sub").file = null;
    }
    changePhoto_sub = async (file) => {
        if (!file.type.includes("image")) {
            alert("error", "แจ้งเตือน", "ไม่สามารถอัพโหลดไฟล์ได้เนื่องจากไม่รองรับรูปแบบไฟล์");
            return
        }
        let reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = (e) => { }
        new Promise((resolve) => {
            Resizer.imageFileResizer(
                file, 512, 512, "JPG", 100, 0,
                (uri) => {
                    let item_list = this.state.item_list;
                    item_list[this.state.index].pre_po_list[this.state.product_index].picture = uri.split(",")[1];
                    this.setState({ item_list: item_list });
                },
                "base64"
            );
        });
    }
    render() {
        return (
            <div className="w-100 min-vh-100 fade-in">
                {this.state.loading && (<div className="spinner-container"> <div className="loading-spinner"></div> </div>)}
                <Navbar page1="หน้าหลัก" page2="แดชบอร์ด" />
                {/* BODY */}
                <div className="body bg-light min-vh-100">
                    <div className="p-3">
                        {/* หัวข้อ และ ปุ่มเพิ่ม */}
                        <div className="d-flex mx-0 align-items-center justify-content-between test mb-2 flex-wrap">
                            <h3 className="mb-2"><b>บันทึกรออนุมัติสั่งซื้อ : {this.state.pre_po_main_number}</b></h3>
                            <button className="btn btn-outline-orange mx-1" onClick={() => { window.location.href = "/order/list-approve-order" }}>
                                <span className="icon me-2">{"\uf060"}</span>ย้อนกลับ
                            </button>
                        </div>
                        <div className="w-100 card border-0 p-3 rounded-lg">
                            <div className="row">
                                <div className="col-12 col-md-4 col-lg-2">
                                    <label className="mb-2">วันที่เอกสาร:</label>
                                    <DatePicker
                                        className="form-control mb-2"
                                        placeholder="พิมพ์คำค้นหา..."
                                        onChange={(e) => {
                                            this.setState({ date: e });
                                        }}
                                        value={this.state.date}
                                        disabled={this.state.readOnly}
                                    />
                                </div>
                                <div className="col-12 col-md-4 col-lg-2">
                                    <label className="mb-2">ทะเบียนรถ:</label>
                                    <Select
                                        className="form-control select-search"
                                        styles={select_style}
                                        options={this.state.data_license_plate.filter(e => !this.state.member_name || e.member_id === this.state.member_name.member_id)}
                                        onChange={(e) => {
                                            this.setState({ remark: e });
                                        }}
                                        value={this.state.remark}
                                        isClearable
                                        isDisabled={this.state.readOnly}
                                    ></Select>
                                </div>
                            </div>
                            <input className="d-none" type="file" id="file" accept="image/*" onChange={(e) => { this.import_file(e) }} />
                            <input className="d-none" type="file" id="file_sub" accept="image/*" onChange={(e) => { this.import_file_sub(e) }} />

                            {this.state.item_list && this.state.item_list.map((item, index) => (
                                <div className="card bg-contain p-3 border-0 mb-2">
                                    <div className="d-flex align-items-center justify-content-between mb-2">
                                        <b className="mb-2 d-flex align-items-center">บริษัทจำหน่าย: {item.company_id.label}
                                            {!item.decision_status && !this.state.readOnly && (
                                                <div className="pointer wpx-30 hpx-30 rounded bg-danger-light mx-1 d-flex justify-content-center align-items-center"
                                                    onClick={() => {
                                                        Swal.fire({
                                                            icon: "warning",
                                                            title: "แจ้งเตือน",
                                                            text: "ยืนยันการลบ \"บริษัทจำหน่าย: " + item.company_id.label + "\" หรือไม่ \nหากลบแล้วจะไม่สามารถย้อนคืนข้อมูลที่ลบไปได้",
                                                            confirmButtonText: "ตกลง",
                                                            cancelButtonText: "ยกเลิก",
                                                            showCancelButton: true,
                                                        }).then((result) => {
                                                            if (result.isConfirmed) {
                                                                let item_list = this.state.item_list;
                                                                item_list.splice(index, 1);
                                                                this.setState({ item_list: item_list });
                                                            }
                                                        });
                                                    }}>
                                                    <label className="pointer icon text-danger p-2">{"\uf2ed"}</label>
                                                </div>
                                            )}
                                        </b>
                                        <div className="d-flex align-items-center" style={{ marginRight: 100 }}>
                                            <label className="mx-3">สถานะ:</label>
                                            <label className="mx-1">รออนุมัติ</label>
                                            <Switch onChange={(e) => {
                                                Swal.fire({
                                                    icon: "warning",
                                                    title: "แจ้งเตือน",
                                                    text: "ยืนยันการอนุมัติสถานะของ \"บริษัทจำหน่าย: " + item.company_id.label + "\" หรือไม่ \nหากอนุมัติแล้วจะไม่สามารถเพิ่มหรือลบรายการได้อีก",
                                                    confirmButtonText: "ตกลง",
                                                    cancelButtonText: "ยกเลิก",
                                                    showCancelButton: true,
                                                }).then((result) => {
                                                    if (result.isConfirmed) {
                                                        let item_list = this.state.item_list;
                                                        if (e === true) {
                                                            for (let a of item_list) {
                                                                a.decision_status = false;
                                                            }
                                                        }
                                                        item_list[index].decision_status = e;
                                                        this.setState({ item_list: item_list });
                                                    }
                                                });

                                            }}
                                                checked={item.decision_status}
                                                offColor={"#f00"}
                                                disabled={this.state.readOnly}
                                            />
                                            <label className="mx-1">อนุมัติ</label>
                                        </div>
                                    </div>
                                    <div>
                                        <table className="table table-borderless table-striped">
                                            <thead>
                                                <tr className="bg-primary text-white">
                                                    <td className="text-center wpx-60">รูปภาพ</td>
                                                    <td className="text-left">ชื่อสินค้า</td>
                                                    <td className="text-center wpx-100">จำนวน</td>
                                                    <td className="text-end wpx-100">ราคาต่อหน่วย</td>
                                                    <td className="text-end wpx-120">ยอดรวมทั้งหมด</td>
                                                    <td className="text-left wpx-50"></td>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {item.pre_po_list.map((product, product_index) => (
                                                    <tr>
                                                        <td className="text-center">
                                                            {product.picture ? (
                                                                <div className="d-flex">
                                                                    <img alt="รูปสาขา" src={product.picture.includes("https://") ? product.picture : "data:image/png;base64," + product.picture} className="wpx-30 hpx-30 rounded-circle bg-secondary"></img>
                                                                    <div className="pointer wpx-30 hpx-30 rounded bg-danger-light mx-1 d-flex justify-content-center align-items-center"
                                                                        onClick={() => {
                                                                            Swal.fire({
                                                                                icon: "warning",
                                                                                title: "แจ้งเตือน",
                                                                                text: "ยืนยันการลบรูปภาพนี้หรือไม่",
                                                                                confirmButtonText: "ตกลง",
                                                                                cancelButtonText: "ยกเลิก",
                                                                                showCancelButton: true,
                                                                            }).then((result) => {
                                                                                if (result.isConfirmed) {
                                                                                    let item_list = this.state.item_list;
                                                                                    item_list[index].pre_po_list[product_index].picture = "";
                                                                                    this.setState({ item_list: item_list });
                                                                                }
                                                                            });
                                                                        }}>
                                                                        <label className="pointer icon text-danger p-2">{"\uf2ed"}</label>
                                                                    </div>
                                                                </div>
                                                            ) : (
                                                                <div className="wpx-30 hpx-30 rounded-circle bg-secondary d-flex justify-content-center align-items-center pointer"
                                                                    onClick={() => {
                                                                        if (!item.decision_status && !this.state.readOnly) {
                                                                            this.setState({
                                                                                index: index,
                                                                                product_index: product_index
                                                                            });
                                                                            document.getElementById("file_sub").click();
                                                                        }
                                                                    }}>
                                                                    <label className="icon text-white pointer">{"\uf0ee"}</label>
                                                                </div>
                                                            )}
                                                        </td>
                                                        <td>
                                                            <Select
                                                                className="form-control select-search"
                                                                styles={select_style}
                                                                options={this.state.data_product}
                                                                onChange={(e) => {
                                                                    console.log(e)
                                                                    let item_list = this.state.item_list;
                                                                    item_list[index].pre_po_list[product_index].product_code = e;
                                                                    if (e) {
                                                                        item_list[index].pre_po_list[product_index].price_by_item = e.sell_price;
                                                                    }
                                                                    this.setState({ item_list: item_list });
                                                                }}
                                                                value={product.product_code}
                                                                isClearable
                                                                isDisabled={item.decision_status || this.state.readOnly}
                                                            ></Select>
                                                        </td>
                                                        <td>
                                                            <input
                                                                className="form-control mb-2 text-end"
                                                                type="text"
                                                                placeholder=""
                                                                onChange={(e) => {
                                                                    if (!float(e.target.value)) {
                                                                        return
                                                                    }
                                                                    let item_list = this.state.item_list;
                                                                    item_list[index].pre_po_list[product_index].quantity = Number(e.target.value);
                                                                    item_list[index].pre_po_list[product_index].total_price_by_item = item_list[index].pre_po_list[product_index].quantity * Number(item_list[index].pre_po_list[product_index].price_by_item);
                                                                    this.setState({ item_list: item_list });
                                                                }}
                                                                value={product.quantity}
                                                                readOnly={item.decision_status || this.state.readOnly}
                                                            />
                                                        </td>
                                                        <td className="text-end">
                                                            <input
                                                                className="form-control mb-2 text-end"
                                                                type="text"
                                                                placeholder=""
                                                                onChange={(e) => {
                                                                    if (!float(e.target.value)) {
                                                                        return
                                                                    }
                                                                    let item_list = this.state.item_list;
                                                                    item_list[index].pre_po_list[product_index].price_by_item = e.target.value;
                                                                    item_list[index].pre_po_list[product_index].total_price_by_item = item_list[index].pre_po_list[product_index].quantity * Number(item_list[index].pre_po_list[product_index].price_by_item);
                                                                    this.setState({ item_list: item_list });
                                                                }}
                                                                value={product.price_by_item}
                                                                readOnly={item.decision_status || this.state.readOnly}
                                                            />

                                                        </td>
                                                        <td className="text-end">{toFixed(product.total_price_by_item)}

                                                        </td>
                                                        <td>
                                                            {!item.decision_status && !this.state.readOnly && (
                                                                <div className="w-100 d-flex justify-content-center">
                                                                    <div className="pointer wpx-30 hpx-30 rounded bg-danger-light mx-1 d-flex justify-content-center align-items-center"
                                                                        onClick={() => {
                                                                            Swal.fire({
                                                                                icon: "warning",
                                                                                title: "แจ้งเตือน",
                                                                                text: "ยืนยันการลบ \"" + product.product_code.label + "\" หรือไม่ \nหากลบแล้วจะไม่สามารถย้อนคืนข้อมูลที่ลบไปได้",
                                                                                confirmButtonText: "ตกลง",
                                                                                cancelButtonText: "ยกเลิก",
                                                                                showCancelButton: true,
                                                                            }).then((result) => {
                                                                                if (result.isConfirmed) {
                                                                                    let item_list = this.state.item_list;
                                                                                    item_list[index].pre_po_list.splice(product_index, 1);
                                                                                    this.setState({ item_list: item_list });
                                                                                }
                                                                            });
                                                                        }}>
                                                                        <label className="pointer icon text-danger p-2">{"\uf2ed"}</label>
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </td>
                                                    </tr>
                                                ))}
                                                {!this.state.readOnly && (
                                                    <tr>
                                                        <td>
                                                            {item.picture ? (
                                                                <div className="d-flex">
                                                                    <img alt="รูปสาขา" src={item.picture.includes("https://") ? item.picture : "data:image/png;base64," + item.picture} className="wpx-30 hpx-30 rounded-circle bg-secondary"></img>
                                                                    <div className="pointer wpx-30 hpx-30 rounded bg-danger-light mx-1 d-flex justify-content-center align-items-center"
                                                                        onClick={() => {
                                                                            Swal.fire({
                                                                                icon: "warning",
                                                                                title: "แจ้งเตือน",
                                                                                text: "ยืนยันการลบรูปภาพนี้หรือไม่",
                                                                                confirmButtonText: "ตกลง",
                                                                                cancelButtonText: "ยกเลิก",
                                                                                showCancelButton: true,
                                                                            }).then((result) => {
                                                                                if (result.isConfirmed) {
                                                                                    let item_list = this.state.item_list;
                                                                                    item_list[index].picture = "";
                                                                                    this.setState({ item_list: item_list });
                                                                                }
                                                                            });
                                                                        }}>
                                                                        <label className="pointer icon text-danger p-2">{"\uf2ed"}</label>
                                                                    </div>
                                                                </div>
                                                            ) : (
                                                                <div className="wpx-30 hpx-30 rounded-circle bg-secondary d-flex justify-content-center align-items-center pointer"
                                                                    onClick={() => {
                                                                        if (!item.decision_status && !this.state.readOnly) {
                                                                            this.setState({ index: index });
                                                                            document.getElementById("file").click();
                                                                        }
                                                                    }}>
                                                                    <label className="icon text-white pointer">{"\uf0ee"}</label>
                                                                </div>
                                                            )}
                                                        </td>
                                                        <td>
                                                            <Select
                                                                className="form-control select-search"
                                                                styles={select_style}
                                                                options={this.state.data_product}
                                                                onChange={(e) => {
                                                                    console.log(e)
                                                                    let item_list = this.state.item_list;
                                                                    item_list[index].product_code = e;
                                                                    if (e) {
                                                                        item_list[index].price_by_item = e.sell_price;
                                                                    }
                                                                    this.setState({ item_list: item_list });
                                                                }}
                                                                value={item.product_code}
                                                                isClearable
                                                                isDisabled={item.decision_status}
                                                            ></Select>
                                                        </td>
                                                        <td>
                                                            <input
                                                                className="form-control mb-2"
                                                                type="text"
                                                                placeholder=""
                                                                onChange={(e) => {
                                                                    if (!float(e.target.value)) {
                                                                        return
                                                                    }
                                                                    let item_list = this.state.item_list;
                                                                    item_list[index].quantity = Number(e.target.value);
                                                                    this.setState({ item_list: item_list });
                                                                }}
                                                                value={item.quantity}
                                                                readOnly={item.decision_status}
                                                            />
                                                        </td>
                                                        <td className="text-end">
                                                            <input
                                                                className="form-control mb-2 text-end"
                                                                type="text"
                                                                placeholder=""
                                                                onChange={(e) => {
                                                                    if (!float(e.target.value)) {
                                                                        return
                                                                    }
                                                                    let item_list = this.state.item_list;
                                                                    item_list[index].price_by_item = e.target.value;
                                                                    this.setState({ item_list: item_list });
                                                                }}
                                                                value={item.price_by_item}
                                                                readOnly={item.decision_status}
                                                            />
                                                        </td>
                                                        <td className="text-end">
                                                            <div className="pt-2">
                                                                <label className="mb-2">{toFixed(item.quantity * item.price_by_item)}</label>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            {!item.decision_status && (
                                                                <div className="w-100 d-flex justify-content-center">
                                                                    <div className="wpx-30 hpx-30 rounded-circle bg-blue text-24 text-white d-flex justify-content-center align-items-center pointer"
                                                                        onClick={() => {
                                                                            if (!item.product_code) {
                                                                                alert("warning", "แจ้งเตือน", "กรุณาเลือกสินค้า");
                                                                                return;
                                                                            } else if (!item.quantity) {
                                                                                alert("warning", "แจ้งเตือน", "กรุณากรอกจำนวน");
                                                                                return;
                                                                            } else if (!item.price_by_item) {
                                                                                alert("warning", "แจ้งเตือน", "กรุณากรอกราคาต่อหน่วย");
                                                                                return;
                                                                            }
                                                                            let item_list = this.state.item_list;
                                                                            item_list[index].pre_po_list.push({
                                                                                pre_po_list_id: "",
                                                                                picture: item.picture,
                                                                                product_code: item.product_code,
                                                                                quantity: Number(item.quantity),
                                                                                price_by_item: Number(item.price_by_item),
                                                                                total_price_by_item: Number(item.quantity) * Number(item.price_by_item)
                                                                            })
                                                                            item_list[index].picture = "";
                                                                            item_list[index].product_code = "";
                                                                            item_list[index].quantity = "";
                                                                            item_list[index].price_by_item = "";
                                                                            this.setState({
                                                                                item_list: item_list
                                                                            })
                                                                        }}>+</div>
                                                                </div>
                                                            )}
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>

                                </div>
                            ))}
                            {!this.state.readOnly && (
                                <div className="w-100 py-3 d-flex align-items-center justify-content-between">
                                    <button className="btn btn-primary mx-1 px-5" onClick={() => {
                                        this.setState({ modal_add_supplier: true, company_id: "" })
                                    }}>
                                        <span className="icon me-2">{"\uf055"}</span>
                                        เพิ่มบริษัทจำหน่าย
                                    </button>
                                    <div className="d-flex">
                                        <button className="btn btn-outline-orange mx-1 px-5" onClick={() => { }}>
                                            ยกเลิก
                                        </button>
                                        <button className="btn btn-orange mx-1 px-5" onClick={() => {
                                            if (this.props.location.query.id) {
                                                this.Update()
                                            } else {
                                                this.Create()
                                            }
                                        }}>
                                            บันทึก
                                        </button>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                {/* create update */}
                <Modal show={this.state.modal_add_supplier}
                    onHide={() => { this.setState({ modal_add_supplier: false }) }}>
                    <Modal.Header><Modal.Title><b>เลือกบริษัทจำหน่าย</b></Modal.Title></Modal.Header>
                    <Modal.Body>
                        {/* ชื่อบริษัท */}
                        <div className="w-100 mb-2">
                            <label className="mb-2">ชื่อบริษัท:</label>
                            <Select
                                className="form-control select-search"
                                styles={select_style}
                                options={this.state.data_supplier}
                                onChange={(e) => {
                                    this.setState({ company_id: e });
                                }}
                                value={this.state.company_id}
                                isClearable
                            ></Select>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <div className="w-100 d-flex">
                            <div className="w-50 pe-1">
                                <button className="btn btn-outline-orange w-100" onClick={() => { this.setState({ modal_add_supplier: false }) }}>
                                    ยกเลิก
                                </button>
                            </div>
                            <div className="w-50 ps-1">
                                <button className="btn btn-orange w-100"
                                    onClick={() => {
                                        if (!this.state.company_id) {
                                            alert("warning", "แจ้งเตือน", "กรุณาเลือกบริษัทจำหน่าย")
                                        }
                                        let item_list = this.state.item_list;
                                        item_list.push({
                                            pre_po_center_id: "",
                                            company_id: this.state.company_id,
                                            decision_status: false,
                                            picture: "",
                                            product_code: "",
                                            quantity: "",
                                            price_by_item: "",
                                            pre_po_list: []
                                        });
                                        this.setState({ item_list: item_list, modal_add_supplier: false });
                                    }}>
                                    เพิ่ม
                                </button>
                            </div>
                        </div>
                    </Modal.Footer>
                </Modal>
            </div >
        )
    }
}
